export default () => {
    return function (input) {
        if (input) {
            return input.replace(/ /g, '-').toLowerCase();
        } else {
            return input;
        }
    };
};
